import { useAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { globalDownloadAssetAtom } from '@/atoms/globalDownload';
import ConfirmDownloadModal from '@/components/Modals/ConfirmDownload';
import type { AssetGroup } from '@/types/asset';
const isPremiumAsset = (asset: AssetGroup): boolean => Boolean((asset.data as {
  is_premium?: boolean;
}).is_premium);

/**
 * A ConfirmDownload driven by an atom rather than a button, mounted once
 * globally. It lets flows that live outside a download button — the
 * DialogStage's returning-user login (DEV-6514) — open the standard download
 * popup (or its upsell) for an asset once the user is authenticated.
 *
 * The atom is consumed into local state so it's a fire-and-forget signal: the
 * modal stays mounted through the download and clears itself on close, leaving
 * the atom free for the next request. `key` per asset remounts the inner modal
 * so its one-shot auto-open fires each time.
 */
const GlobalDownloadModal = () => {
  const [requested, setRequested] = useAtom(globalDownloadAssetAtom);
  const [asset, setAsset] = useState<AssetGroup | null>(null);
  useEffect(() => {
    if (requested) {
      setAsset(requested);
      setRequested(null);
    }
  }, [requested, setRequested]);
  if (!asset) {
    return null;
  }
  return <ConfirmDownloadModal asChild asset={asset} autoOpen key={`${asset.type}-${asset.data.id}`} onClose={() => setAsset(null)} premium={isPremiumAsset(asset)} data-sentry-element="ConfirmDownloadModal" data-sentry-component="GlobalDownloadModal" data-sentry-source-file="GlobalDownloadModal.tsx">
      <button aria-hidden className="hidden" tabIndex={-1} type="button" />
    </ConfirmDownloadModal>;
};
export default GlobalDownloadModal;